import { withBemMod } from '@bem-react/core';
import React, { FC, ReactElement } from 'react';
import './Icon_type_camera.css';

export interface WithTypeCameraProps {
  type?: 'camera';
}

export const withTypeCamera = withBemMod<WithTypeCameraProps>(
    'Icon',
    { type: 'camera' },
    (Icon): FC => ((props): ReactElement => (<Icon {...props} />)),
);

export default withTypeCamera;
